import { getConditionalObject } from 'utils/data';

export class CompanyRoleRestrictionsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getRestrictions({ companyId, skipForbiddenError } = {}) {
    return this.#http.get(`/api/companies/${companyId}/role-restrictions`, {
      ...getConditionalObject(skipForbiddenError, {
        skipResponseInterceptor: { forbiddenError: true },
      }),
    });
  }

  async updateRestrictions({ companyId, restrictedRoleIds }) {
    return this.#http.put(`/api/companies/${companyId}/role-restrictions`, restrictedRoleIds);
  }
}
